import http from '../http';

// CREATE (multipart)
export async function createProduct(payload) {
  const {
    title, brand = '',
    priceRetail, priceWholesale,
    costPrice = '',
    shortDesc = '', fullDesc = '',
    topCategorySlug, subcategoryId,
    attributes = {},
    primaryIndex = 0,
    images = [],
    weightKg = '',
    lengthMm = '', widthMm = '', heightMm = ''
  } = payload;

  const fd = new FormData();
  fd.append('title', title);
  fd.append('brand', brand);
  fd.append('priceRetail', String(priceRetail));
  fd.append('priceWholesale', String(priceWholesale));
  fd.append('costPrice', String(costPrice));
  fd.append('stockQty', '0');
  fd.append('sku', String(payload.sku || ''));
  fd.append('color', String(payload.color || ''));
  fd.append('country', String(payload.country || ''));
  fd.append('warrantyMonths', String(payload.warrantyMonths ?? ''));

  if (shortDesc) fd.append('shortDesc', shortDesc);
  if (fullDesc) fd.append('fullDesc', fullDesc);

  fd.append('topCategorySlug', topCategorySlug);
  if (subcategoryId) fd.append('subcategoryId', subcategoryId);

  fd.append('primaryIndex', String(primaryIndex));
  fd.append('attributes', JSON.stringify(attributes || {}));

  // логистика
  if (weightKg !== '') fd.append('weightKg', String(weightKg));
  if (lengthMm !== '') fd.append('lengthMm', String(lengthMm));
  if (widthMm !== '') fd.append('widthMm', String(widthMm));
  if (heightMm !== '') fd.append('heightMm', String(heightMm));

  images.forEach(f => fd.append('images', f));

  // ✅ ВАЖНО: админский путь
  const { data } = await http.post('/api/admin/products', fd, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
}

// READ (admin)
export async function fetchProductById(id) {
  // ✅ ВАЖНО: админский путь
  const { data } = await http.get(`/api/admin/products/${id}`);
  return data;
}

// UPDATE (multipart)
export async function updateProduct(id, payload) {
  const {
    title, brand,
    priceRetail, priceWholesale, costPrice,
    shortDesc, fullDesc,
    topCategorySlug, subcategoryId,
    attributes = {},
    primaryIndex = 0,
    imagesKeep = [],      // массив URL, которые оставить
    imagesNew = [],       // File[]
    weightKg, lengthMm, widthMm, heightMm,
  } = payload;

  const fd = new FormData();
  if (title !== undefined) fd.append('title', title);
  if (brand !== undefined) fd.append('brand', brand);
  if (priceRetail !== undefined) fd.append('priceRetail', String(priceRetail));
  if (priceWholesale !== undefined) fd.append('priceWholesale', String(priceWholesale));
  if (costPrice !== undefined) fd.append('costPrice', String(costPrice));
  if (payload.sku !== undefined) fd.append('sku', String(payload.sku));
  if (payload.color !== undefined) fd.append('color', String(payload.color));
  if (payload.country !== undefined) fd.append('country', String(payload.country));
  if (payload.warrantyMonths !== undefined) fd.append('warrantyMonths', String(payload.warrantyMonths));

  if (shortDesc !== undefined) fd.append('shortDesc', shortDesc);
  if (fullDesc !== undefined) fd.append('fullDesc', fullDesc);

  if (topCategorySlug !== undefined) fd.append('topCategorySlug', topCategorySlug);
  if (subcategoryId !== undefined) fd.append('subcategoryId', subcategoryId);

  fd.append('attributes', JSON.stringify(attributes || {}));
  fd.append('primaryIndex', String(primaryIndex));
  fd.append('imagesKeep', JSON.stringify(imagesKeep || []));

  if (weightKg !== undefined) fd.append('weightKg', String(weightKg));
  if (lengthMm !== undefined) fd.append('lengthMm', String(lengthMm));
  if (widthMm !== undefined) fd.append('widthMm', String(widthMm));
  if (heightMm !== undefined) fd.append('heightMm', String(heightMm));

  (imagesNew || []).forEach(f => fd.append('imagesNew', f));

  // ✅ ВАЖНО: админский путь
  const { data } = await http.put(`/api/admin/products/${id}`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
}

export async function deleteProduct(id) {
  // ✅ ВАЖНО: админский путь
  const { data } = await http.delete(`/api/admin/products/${id}`);
  return data;
}

// если у тебя есть отдельный endpoint активности — добавь сюда
export async function setProductActive(id, active) {
  const { data } = await http.patch(`/api/admin/products/${id}/active`, { isActive: Boolean(active) });
  return data;
}
